import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import SEO from "@/components/SEO";
import PageHero from "@/components/site/PageHero";
import Reveal from "@/components/site/Reveal";
import FaqAccordion from "@/components/site/FaqAccordion";
import { ContactCTA } from "@/pages/Home";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => {
    api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {});
  }, []);

  const categories = [...new Set(faqs.map((f) => f.category))];

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.question,
      acceptedAnswer: { "@type": "Answer", text: f.answer },
    })),
  };

  return (
    <>
      <SEO title="FAQ" description="Frequently asked questions about working with Web Vantage Enterprises — process, pricing, timelines and support." path="/faq" schema={schema} />
      <PageHero
        overline="FAQ"
        title="Everything you need to know"
        subtitle="Can't find an answer? Our team is one message away."
        crumbs={[{ label: "FAQ" }]}
      />
      <section className="py-20 lg:py-28">
        <div className="container-wv max-w-4xl space-y-14">
          {categories.map((cat) => (
            <div key={cat}>
              <h2 className="mb-6 font-heading text-2xl font-semibold text-white">{cat}</h2>
              <Reveal><FaqAccordion items={faqs.filter((f) => f.category === cat)} testid={`faq-${cat.toLowerCase()}`} /></Reveal>
            </div>
          ))}
        </div>
      </section>
      <ContactCTA />
    </>
  );
}
